import {
  ChangeDetectorRef,
  Directive,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { PluginInjectorWidget } from 'core-client/api';
import { WidgetHostRegistry } from './widget-host-registry.service';

@Directive({
  selector: '[appWidgetItem]',
  standalone: true
})
export class WidgetDirective implements OnInit, OnChanges, OnDestroy {
  @Input('appWidgetItem') widget!: PluginInjectorWidget.IWidget;
  @Input('isHeaderHovered') isHeaderHovered: boolean = false;

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly widgetHosts = inject(WidgetHostRegistry);
  private destroyed = false;

  async ngOnInit(): Promise<void> {
    const host = await this.widgetHosts.acquire(this.widget, this.isHeaderHovered);
    if (!host || this.destroyed) {
      return;
    }
    this.widgetHosts.mount(host, this.viewContainerRef);
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hovered = changes['isHeaderHovered'];
    if (hovered && !hovered.firstChange) {
      this.widgetHosts.setHeaderHovered(this.widget._id, this.isHeaderHovered);
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
